import { setAccessToken } from '@/lib/api';

const API_BASE = process.env.NEXT_PUBLIC_API_URL ?? 'https://api.ucheta.ru';

export interface OAuthProvider {
  id: string;
  label: string;
  /** Публичный client_id (Яндекс Suggest) */
  client_id?: string;
  /** Redirect URI вспомогательной страницы Suggest */
  suggest_redirect_uri?: string;
}

export async function fetchOAuthProviders(): Promise<OAuthProvider[]> {
  const response = await fetch(`${API_BASE}/api/v1/auth/oauth/providers`, {
    headers: { Accept: 'application/json' },
    credentials: 'include',
    cache: 'no-store',
  });

  if (!response.ok) {
    return [];
  }

  const data = await response.json();
  return Array.isArray(data.providers) ? data.providers : [];
}

export function buildOAuthRedirectUrl(providerId: string, redirectPath = '/'): string {
  const params = new URLSearchParams();
  params.set('frontend_origin', 'app');
  params.set('registration_source', 'app');
  if (redirectPath && redirectPath !== '/') {
    params.set('redirect', redirectPath);
  }

  return `${API_BASE}/api/v1/auth/oauth/${providerId}/redirect?${params.toString()}`;
}

export async function exchangeOAuthCode(code: string): Promise<{
  access_token: string;
}> {
  const response = await fetch(`${API_BASE}/api/v1/auth/oauth/exchange`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify({ code }),
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message ?? 'Не удалось завершить OAuth-вход');
  }

  if (typeof data.access_token === 'string') {
    setAccessToken(data.access_token, true);
  }

  return data;
}

export async function loginWithYandexAccessToken(
  accessToken: string,
  redirectPath = '/',
): Promise<{
  access_token: string;
  redirect?: string;
}> {
  const response = await fetch(`${API_BASE}/api/v1/auth/oauth/yandex/token`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify({
      access_token: accessToken,
      redirect: redirectPath,
      frontend_origin: 'app',
      registration_source: 'app',
    }),
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message ?? 'Не удалось войти через Яндекс ID');
  }

  if (typeof data.access_token === 'string') {
    setAccessToken(data.access_token, true);
  }

  return data;
}
